module.exports = __webpack_public_path__ + "static/berlin-project-thumbnail-b67a7d6d92cb044a169904ccc704b700.jpg";